import './en';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ngx-bootstrap/bs-moment/locale/index.js
// module id = ../../../../ngx-bootstrap/bs-moment/locale/index.js
// module chunks = 3